import { jsx as _jsx } from "theme-ui/jsx-runtime";
export const SmallArrowLeft = props => {
    return (_jsx("svg", Object.assign({ width: "4", height: "6", viewBox: "0 0 4 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" }, props, { children: _jsx("path", { d: "M4 6L1.28151 3L4 0L2.71849 0L0 3L2.71849 6H4Z", fill: "currentColor" }) })));
};
//# sourceMappingURL=ArrowLeftSmall.js.map